var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{ref:"myIframe",staticStyle:{"width":"100%","flex":"1"},attrs:{"src":"/emr-nursing-record4.html"},on:{"load":_vm.sendDataToIframe}})])}
var staticRenderFns = []

export { render, staticRenderFns }